import React, { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import { api } from "@/lib/api";

export default function Learning() {
  const [paths, setPaths] = useState([]);
  useEffect(() => { (async () => setPaths(await api.paths()))(); }, []);

  return (
    <div className="bg-[color:var(--f2-bg)] min-h-screen text-white">
      <Nav />
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-16">
        <div className="label-xs mb-2">§ Learning Pathways</div>
        <h1 className="font-display uppercase tracking-tighter font-black text-4xl md:text-6xl mb-10">
          Curriculum for the <span className="saffron">space age.</span>
        </h1>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {paths.map((p) => (
            <div key={p.path_id} data-testid={`path-${p.path_id}`} className="hard-border p-6 bg-[color:var(--f2-surface)]">
              <div className="flex justify-between label-xs mb-4">
                <span className="saffron">{p.focus}</span>
                <span>{p.level}</span>
              </div>
              <h3 className="font-display font-bold text-xl mb-3">{p.title}</h3>
              <div className="label-xs mb-4">{p.hours}h · Cohort-based</div>
              <ul className="space-y-1 text-xs text-[color:var(--f2-muted)]">
                {p.outcomes?.map((o, i) => <li key={i}>◆ {o}</li>)}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
